/**
 * http请求 loading计数器
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: true })

let timeouterID
let counter = 0

export default {
  /**
   * 显示loading
   * 增加计数器
   *
   * @param {object} config - http 配置参数
   *
   * @returns {undefined}
   */
  start(config) {
    if (!config.meta.showLoading) return false

    // loading计数器加1
    counter++

    // 判断是否已存在延迟器，若已存在，则不再复复创建
    const delayTime = config.meta.loadingDelayTime

    // 定时器若已存在，则不再处理lodaing的显示
    if (!timeouterID) {
      if (delayTime > 0) {
        timeouterID = setTimeout(() => {
          NProgress.start()
        }, delayTime)
      } else {
        NProgress.start()
      }
    }
  },

  /**
   * 隐藏loading
   * 减少计算器，当减少至0时，隐藏弹窗
   *
   * @param {object} config - http 配置参数
   *
   * @returns {undefined}
   */
  done(config) {
    if (!config.meta.showLoading) return false

    counter--

    // 计数器为0时
    if (counter > 0) return false

    // 设置结束时间
    clearTimeout(timeouterID)
    timeouterID = undefined
    NProgress.done()
  },
}
